import * as types from './actionTypes';
import getAPIPath from '../../js/modules/api-location';

export function canIAccessSuccess(data) {
  return { type: types.CAN_I_ACCESS_SUCCESS, data };
}

export function canIAccess(contentId, modelType) {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/allowed-to-access?content_id=${contentId}&model_type=${modelType}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => {
      response.json().then((res) => {
        dispatch(canIAccessSuccess(res.data));
      });
    }).catch((error) => {
      throw (error);
    });
  };
}


//123


// WEBPACK FOOTER //
// ./library/app/actions/accessActions.js